import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { breakpointWidth } from '../constants';

export const InnerRowContainer = styled.div`
  width: 100%;
  padding: 0 94px;
  max-width: 1440px;
  align-self: center;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: ${breakpointWidth}px) {
    padding: 0 26px;
  }
`;

export const OuterRowContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  padding-bottom: 40px;
`;

interface IRowContainerProps {
  children?: React.ReactNode;
  className?: string;
}
export const RowContainer = forwardRef<HTMLDivElement, IRowContainerProps>(({ className, children }, ref) => (
  <OuterRowContainer className={className} ref={ref}>
    <InnerRowContainer>{children}</InnerRowContainer>
  </OuterRowContainer>
));
